const ResumeApi = [
  {
    id: 1,
    category: "education",
    year: "Oulu University Applied of Science (OAMK), Oulu, FINLAND (2024)",
    title: "Modern Software and Computing Solutions",
    desc: "Master´s Degree in Modern Software and Computing Solutions",
  },
  {
    id: 2,
    category: "education",
    year: "Tampere University Applied of Science (TAMK), TAMPERE, FINLAND (2015-2020)",
    title: "Energy And Environment Engineer",
    desc: "Bachelor of Engineer in Energy and Environment Engineer. Major in Circular Economy",
  },
  {
    id: 3,
    category: "experience",
    year: "AEM Afore oy ,Turku ,Finland (7/2025 - Present)",
    title: "Software developer",
    desc: "• Built React (TypeScript) components integrated with .NET Core APIs, improving UX and enabling fasteriteration cyles.\n• Modernization of a large ASP.NET MVC 4.8 platform to ASP.NET Core 9, introducing DependencyInjection, middleware rouFng, authentication, and distributed caching.\n• Refactored data access layer to Enpty Framework Core,build maintainability and cutting query complexity.\n• Drove customer-centric improvements via weekly demos and cross-team collaboration, ensuring zero downtime during migration."
  },
  {
    id: 4,
    category: "experience",
    year: "AEM Afore oy ,Turku ,Finland (4/2023 - 5/2024)",
    title: "Software developer",
    desc: "• Designing, developing, and maintaining software applications using C# and VB .NET.\n• Collaborating with cross-functional teams to understand project requirements and deliver robust solutions.\n• Utilizing XAML to create intuitive and visually appealing user interfaces.\n• Developing GUI components and implementing responsive designs for enhanced user experience.\n• Conducting thorough testing and debugging to ensure high-quality code.\n• Conducting thorough testing and debugging to ensure high-quality code."
  },
  {
    id: 5,
    category: "experience",
    year: "Integrify, HELSINKI, FINLAND (11/2022 - 4/2023)",
    title: "Full-stack developer",
    desc: "Focusing on Frontend development with TypeScript, React.js, and Redux in addition to HTML, CSS, and SASS.\n\n• Emphasis on the Backend with C#, ASP.NET, Databases with MongoDB and SQL Server, and Testing through Unit Testing.\n\n• DevOps practices with CLI Scripting, Docker, and GitHub CI/CD.\n\n• Cloud computing with Microsoft Azure",
  },
  {
    id: 5,
    category: "experience",
    year: "Commu App, TAMPERE, FINLAND (8/2022 - 12/2022)",
    title: "Mobile developer trainee",
    desc: "• As a mobile developer, used React Native to build an app for a marketplace that makes it easier for users to ask for and recieve help.\n\n• The frontend technologies used were React Native and Typescript, while the backend technologies used were PHP, Laravel, and PostgreSQL",
  },

];

export default ResumeApi;
